import BasePolicyModel from '../BasePolicyModel';

// TODO: synthetics alarms are raised by a test rather than an alerting policy. This stands in for a policy, named
// after the test and keyed by the alarm's own grouping, until tests are modeled as alerting policies.
export default class SynthPolicyModel extends BasePolicyModel {
  get dimensions() {
    return this.get('dimensions') || [];
  }
}
